import { render } from "./DatePickerCalendarWeek.vue?vue&type=template&id=a65778c8&scoped=true"
import script from "./DatePickerCalendarWeek.vue?vue&type=script&lang=js"
export * from "./DatePickerCalendarWeek.vue?vue&type=script&lang=js"

import "./DatePickerCalendarWeek.vue?vue&type=style&index=0&id=a65778c8&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a65778c8"]])

export default __exports__